import { Link } from 'react-router-dom';
import { SectionLabel } from '../common/SectionLabel';
import { Card } from '../common/Card';
import { Button } from '../common/Button';

const frameworks = [
  { name: 'Heilmeier', weight: 40 },
  { name: 'WAR', weight: 30 },
  { name: 'Skunk Works', weight: 15 },
  { name: 'Commercial', weight: 10 },
  { name: 'Strategic', weight: 5 },
];

export function FrameworkPreview() {
  return (
    <section className="py-16 px-6 bg-wolf-900/20">
      <div className="max-w-6xl mx-auto">
        <SectionLabel>Evaluation Framework</SectionLabel>
        <h2 className="text-3xl font-bold text-white mb-4">
          Multi-Framework Analysis
        </h2>
        <p className="text-wolf-300 mb-12 max-w-2xl">
          Projects are evaluated against five proven frameworks, each weighted
          by strategic importance.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-12">
          {frameworks.map((framework) => (
            <Card key={framework.name}>
              <p className="font-mono text-2xl text-action mb-1">{framework.weight}%</p>
              <p className="text-sm text-wolf-300">{framework.name}</p>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/framework">
            <Button variant="secondary">View Full Framework</Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
